/**
 * Lightweight logger wrapper — gated by NODE_ENV.
 *
 * In development: forwards to console.* exactly as before.
 * In production: no-op (drops all logs to keep the user console clean).
 *
 * Use this for diagnostic/verbose logging that should NOT leak to the
 * production browser console. For real errors that need persistence,
 * integrate Sentry (or similar) here later.
 */
const isDev = process.env.NODE_ENV !== 'production';

const noop = () => {};

const logger = {
  log: isDev ? console.log.bind(console) : noop,
  warn: isDev ? console.warn.bind(console) : noop,
  // error stays even in production — catch-block diagnostics are valuable
  // and don't expose internal data the way log/warn often do.
  error: console.error.bind(console),
  info: isDev ? console.info.bind(console) : noop,
  debug: isDev ? console.debug.bind(console) : noop,
};

export default logger;
